module.exports = __webpack_public_path__ + "static/media/fall2023.4f229e1d.png";